import React from 'react';
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import axios from "../axios";
import { Services } from "../api/api";

import Dashboard from "../Dashboard";

import {
  Button,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

export default function ServiceUpdate() {
  const { id } = useParams<{
    id: string;
  }>();
  const navigation = useNavigate();
  const [service, setService] = useState<Services>({});

  useEffect(() => {
    axios.get("/services/" + id).then((res) => {
      setService(res.data);
    });
  }, [id]);

  const handleUpdate = () => {
    axios.put("/services/" + id, service).then((_res) => {
      navigation("/services/" + id);
    });
  };

  const handleChangeServiceId = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setService({ ...service, service_id: event.target.value });
  };

  const handleChangeServiceName = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setService({ ...service, service_name: event.target.value });
  };

  const handleChangeMemo = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setService({ ...service, memo: event.target.value });
  };

  return (
    <Dashboard title="サービス管理">
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="サービスID"
                variant="outlined"
                required
                fullWidth
                value={service.service_id}
                onChange={handleChangeServiceId}
                InputLabelProps={{ shrink: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="サービス名"
                variant="outlined"
                required
                fullWidth
                value={service.service_name}
                onChange={handleChangeServiceName}
                InputLabelProps={{ shrink: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="備考"
                variant="outlined"
                required
                multiline
                fullWidth
                value={service.memo}
                onChange={handleChangeMemo}
                InputLabelProps={{ shrink: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br />
      <Grid item xs={12}>
        <Button color="primary" variant="contained" onClick={handleUpdate} sx={{ m: 1 }}>
          Update
        </Button>
      </Grid>
    </Dashboard>
  );
}
